import { Button } from '@flipster/react/design-system';
import { grid } from '@flipster/styled-system/patterns';

const RatioButtons = ({ onClick }: { onClick: (ratio: number) => void }) => {
  return (
    <div className={grid({ gap: 6, gridTemplateColumns: 'repeat(5, 1fr)' })}>
      {[10, 25, 50, 75, 100].map((ratio) => (
        <Button
          key={ratio}
          label={`${ratio}%`}
          color='neutral'
          hierarchy='secondary'
          size='small'
          onClick={() => onClick(ratio)}
        />
      ))}
    </div>
  );
};

export default RatioButtons;
